export const Icon = ({ name , type="solid"}) => {
    const DynamicIcon = () => <i className={`fa-${type} fa-${name}`} />;
    return <DynamicIcon />;
};


